import "@confia/dot-document-auto-capture";
import { useEffect, useCallback } from "react";

const customOption = {
  placeholder: {
    documentPlaceholder: "id-rectangle-dash-front",
  },
  instructions: {
    candidate_selection: "Segure firme",
    document_too_close: "O documento está muito perto",
    document_too_far: "O documento está muito longe",
    document_centering: "Posicione o documento na área indicada",
    document_not_present: "Posicione o documento na área indicada",
    sharpness_too_low: "É necessário mais luz",
    brightness_too_low: "É necessário mais luz",
    brightness_too_high: "É necessário menos luz",
    hotspots_present: "há muito reflexo",
  },
  colors: {
    placeholderColor: "#a8c657",
    placeholderColorSuccess: "#a8c657",
    instructionTextColor: "#ffffff",
    instructionColorSuccess: "#a8c657",
    instructionColor: "#a8c657",
  },
  appStateInstructions: {
    loading: { text: " Carregando. Por favor aguarde." },
    waiting: { text: "Aguardando ..." },
  },
};

function DocumentCamera(props) {
  useEffect(() => {
    const documentAutoCaptureHTMLElement = document.getElementById("x-dot-document-auto-capture");
    documentAutoCaptureHTMLElement.cameraOptions = props;
  });

  return <x-dot-document-auto-capture id="x-dot-document-auto-capture" />;
}

export function ConfiaCapture(props) {
  function handleDocumentPhotoTaken(image, resolution) {
    props.onCapture(image);
  }

  function handleError() {}

  return <DocumentCamera imageType="jpeg" uiCustomisation={customOption} cameraFacing="environment" photoTakenCb={handleDocumentPhotoTaken} onError={handleError} />;
}
